export default "__VITE_ASSET__CqKht$VO__"